import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as PAYROLL_ACTIONS } from "../../../store/actions/payrollActions";
import ReportBtn from "../../report/DownloadReportButton";
import { addDays, subMonths, addYears, subYears } from "date-fns";
import apiURL from "../../../store/actions/apiURL";

import {
	BellIcon,
	ExclamationTriangleIcon,
	CurrencyEuroIcon,
	CurrencyPoundIcon,
	ViewColumnsIcon,
	PencilSquareIcon,
} from "@/icons/solid";

const PayrollAwaitingConfirmation = ({
	updatePayPeriodStatus,
	profile,
	company,
	jurisdiction,
	period,
	org,
	handleConclude,
}) => {
	const [reports, setReports] = useState([]);
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [checkGroupBy, setcheckGroupBy] = useState(false);
	const [totalsOnly, setTotalsOnly] = useState(false);
	const [departmentFilter, setDepartmentFilter] = useState("All");

	useEffect(() => {
		// set loaded right away to avoid a re-trigger
		fetch(apiURL + "/report/templates/", {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// obtained data
				// console.log('data para report',data)
				setReports([
					...fixedReports,
					...data.reports.map((r) => ({
						...r,
						supportedFileTypes: ["xlsx"],
						method: "s3Link",
					})),
				]);
			});
	}, [org]);

	useEffect(() => {
		setStartDate(new Date(period.periodStart));
		setEndDate(new Date(period.periodEnd));
	}, [period]);

	const fixedReports = [
		{
			id: `timesheetLeaveReport`,
			path: `/settings/timesheetLeaveReport`,
			name: `Timesheet & Leave Hours`,
			reportType: `timesheetLeave`,
			supportedFileTypes: ["xlsx"],
			method: "s3Link",
			company: 0,
		},
	];

	return (
		<>
			<div
				className="block text-center bg-white"
				style={{ paddingTop: 80 }}
			>
				<div className="main">
					<h1 className="font-w700 text-center">{`Hey ${profile?.givenName || "User"}!`}</h1>
					<div
						className="item item-circle bg-primary"
						style={{ position: "relative", height: "12rem", width: "12rem", marginBottom: 10 }}
					>
						{jurisdiction == "UK" ? (
							<CurrencyPoundIcon
								style={{
									position: "absolute",
									height: "10rem",
									color: "white",
									right: "1rem",
									top: "1rem",
								}}
							/>
						) : null}
						{jurisdiction == "MT" ? (
							<CurrencyEuroIcon
								style={{
									position: "absolute",
									height: "10rem",
									color: "white",
									right: "1rem",
									top: "1rem",
								}}
							/>
						) : null}
						<ViewColumnsIcon
							style={{
								position: "absolute",
								height: "5rem",
								color: "#ea611c",
								right: "0rem",
								top: "6rem",
								background: "white",
								borderRadius: "5rem",
								padding: "0.5rem",
							}}
						/>
					</div>
					<h3 className="text-center">{`${
						company?.name || "Your company"
					}'s payroll is waiting to be confirmed by their team.`}</h3>
					<div style={{ marginTop: 30 }}>
						<button
							type="button"
							className="btn btn-primary"
							style={{ marginLeft: "2em", marginRight: "2em" }}
						>
							<BellIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left", marginLeft: 5 }}>Remind</div>
						</button>
						<button
							type="button"
							className="btn btn-default"
							onClick={() => updatePayPeriodStatus(period?.id, "Open")}
						>
							<PencilSquareIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left", marginLeft: 5 }}>Amend</div>
						</button>
						<button
							type="button"
							className="btn btn-warning"
							style={{ marginLeft: "2em" }}
							onClick={() => {
								handleConclude();
							}}
						>
							<ExclamationTriangleIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left", marginLeft: 5 }}>Conclude Anyway</div>
						</button>
					</div>
					{reports?.map((report) => {
						if (report.name != "Payroll Report") return;
						return (
							<ReportBtn
								as="button"
								report={report}
								key={report.id}
								enabled={true}
								startDate={startDate}
								endDate={endDate}
								checkGroupBy={checkGroupBy}
								totalsOnly={totalsOnly}
								departmentFilter={departmentFilter}
								showModalOnPress={["4498c949-b3bf-4e7a-9a5d-7ee14aa92d5a"].includes(report.id)}
							/>
						);
					})}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		profile: state?.my?.profile,
		company: state?.company?.settings,
		jurisdiction: state?.jurisdiction?.countryCode,
		period: state.payroll?.payPeriodDetails,
		org: state?.company?.settings?.org,
	};
};

const mapDispatchToProps = (dispatch) => ({
	concludePayroll: (id) => dispatch(PAYROLL_ACTIONS.concludePayroll({ id })),
	updatePayPeriodStatus: (id, status) => dispatch(PAYROLL_ACTIONS.updatePayPeriodStatus(id, status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollAwaitingConfirmation);
